export default "__VITE_ASSET__CpmztZfp__"